/** @jsxImportSource @emotion/react */
import React from 'react';
import * as IconMap from '@hagerty/icons';

import {
  iconBase,
  iconSmall,
  iconLarge,
  iconXLarge,
  icon2xLarge,
  icon3xLarge,
  icon4xLarge,
  iconScale,
  iconDark,
  iconWhite,
  iconBlue,
  iconLight2,
} from './Icon.styles';

import type { SVGProps } from 'react';
import type { IconProps } from './Icon.types';

export function Icon({
  icon,
  size,
  color,
  className,
  testId,
  ...otherProps
}: IconProps): React.ReactElement {
  const styles = [
    iconBase,
    size === 'small' && iconSmall,
    size === 'large' && iconLarge,
    size === 'xlarge' && iconXLarge,
    size === 'xxlarge' && icon2xLarge,
    size === 'xxxlarge' && icon3xLarge,
    size === 'xxxxlarge' && icon4xLarge,
    size === 'scale' && iconScale,
    color === 'dark' && iconDark,
    color === 'white' && iconWhite,
    color === 'blue' && iconBlue,
    color === 'light-2' && iconLight2,
  ];
  const Element: (props: SVGProps<SVGSVGElement>) => JSX.Element =
    IconMap[icon];
  return Element ? (
    <Element
      data-testid={testId}
      css={styles}
      className={className}
      {...otherProps}
    />
  ) : null;
}
